import React, { useEffect, useState } from 'react';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const ClientOnly = function ClientOnly(_ref) {
  let {
    children
  } = _ref;
  const {
    0: hasBeenMounted,
    1: setHasBeenMounted
  } = useState(false);
  useEffect(() => {
    setHasBeenMounted(true);
  }, []);
  if (!hasBeenMounted) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default ClientOnly;
export function withClientOnly(Component) {
  var _ref2, _Component$displayNam;
  const ClientOnlyWrapped = () => /*#__PURE__*/_jsx(ClientOnly, {
    "data-id": "client-only_index_withClientOnly_ClientOnly",
    children: /*#__PURE__*/_jsx(Component, {
      "data-id": "client-only_index_withClientOnly_ClientOnly_Component"
    })
  });
  const wrappedName = (_ref2 = (_Component$displayNam = Component.displayName) !== null && _Component$displayNam !== void 0 ? _Component$displayNam : Component.name) !== null && _ref2 !== void 0 ? _ref2 : React.Component.name;
  ClientOnlyWrapped.displayName = "WithClientOnly(".concat(wrappedName, ")");
  return ClientOnlyWrapped;
}